<template>
    <div>
        <!-- Title when Opened from Work Order View Page-->
        <template v-if="itemId != undefined">
            <div class="form-title">
                <span id="warrantyHeader" v-if="flag == 'update'">Update Warranty Claim</span>
                <span id="warrantyHeader" v-else>Add Warranty Claim</span>
            </div>
        </template>
        <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="WarrantyClaimForm">
            <div class="form-row row-cols-md-4 row-cols-1">
                <div class="col form-group" v-if="$route.params.id > 0">
                    <label class="control-label require" for="code"># Claim:</label>
                    <input type="text" disabled class="form-control"  @keypress="isNumberOnly($event)" v-model="claim_number" id="code" placeholder="Enter Claim Number" name="claim_number">
                    <div class="field-error">{{claim_number_error_msg}}</div>
                </div>
                <div class="col form-group">
                    <label class="control-label require" for="period">Work Order Item:</label>
                    <router-link class="pull-right color-blue link-text" target="_blank" v-bind:to="{name: 'WorkOrderView', params:{id: work_order_id}}">
                        View Work Order
                    </router-link>
                    <v-select v-model="wo_item" name="wo_item" :disabled="collected == 'yes' || from_work_order == true" label="text" :filterable="false" :options="woItemArr" @search="onSearchwoitem" placeholder="Search WO Item" class="custom-ci-auto-search">
                        <template slot="no-options">
                            Search Work order item...
                        </template>
                        <template slot="option" slot-scope="option">
                            <div class="d-center">
                                {{ option.text }}
                            </div>
                        </template>
                        <template slot="selected-option" slot-scope="option">
                            <div class="selected d-center">
                                {{ option.text }}
                            </div>
                        </template>
                    </v-select>
                    <div class="field-error">{{wo_error_msg}}</div>
                </div>
                <div class="col form-group" v-if="itemId == undefined || itemData != ''">
                    <label class="control-label require" for="warranty">Warranty:</label>
                    <v-select v-model="warranty" :disabled="collected == 'yes'" name="warranty" placeholder="Select Warranty."
                        label="text" :options="warrantyArr">
                    </v-select>
                    <div class="field-error">{{warranty_error_msg}}</div>
                </div>
            </div>
            <div class="form-row row-cols-md-4 row-cols-1">
                <!-- <div v-show="unit_no != ''" class="clearfix"></div>
                <div v-if="itemId != undefined" class="clearfix"></div> -->
                <div v-if="unit_no != ''" class="col form-group pt-1">
                    <label class="">#Unit :</label>
                    <span class="label">{{unit_no}}</span>
                </div>
                <div v-if="truck_type != ''" class="col form-group pt-1">
                    <label class="">Unit Type :</label>
                    <span class="label">{{truck_type}}</span>
                </div>
                <div v-if="assigned_facility != ''" class="col form-group pt-1">
                    <label class="">Assigned Facility :</label>
                    <span class="label">{{assigned_facility}}</span>
                </div>
                <div v-if="year != ''" class="col form-group pt-1">
                    <label class="">Year :</label>
                    <span class="label">{{year}}</span>
                </div>
                <div v-if="vin != ''" class="col form-group pt-1">
                    <label class="">#Serial :</label>
                    <span class="label">{{vin}}</span>
                </div>
                <div v-if="make != ''" class="col form-group pt-1">
                    <label class="">Make :</label>
                    <span class="label">{{make}}</span>
                </div>
                <div v-if="model != ''" class="col form-group pt-1">
                    <label class="">Model :</label>
                    <span class="label">{{model}}</span>
                </div>
                <div v-if="woAmount > 0" class="col form-group pt-1">
                    <label class="">WO Cost :</label>
                    <span class="label">{{woAmount}}</span>
                </div>
            </div>
            <div class="form-row row-cols-md-4 row-cols-1">
               <!-- <div v-if="woAmount == 0" class="clearfix"></div> -->
                <div class="col form-group">
                    <label class="control-label require" for="failure_date">Failure Date:</label>
                    <div class="input-group">
                        <date-picker placeholder="MM/DD/YYYY" id="failure_date" name="failure_date" :disabled="collected == 'yes'" v-model="failure_date" :config="optionsDate"></date-picker>
                        <label for="failure_date" class="fp-calendar input-calender-icon"></label>
                    </div>
                    <div class="field-error">{{ failure_date_error_msg }}</div>
                </div>
                <div class="col form-group">
                    <label class="control-label require" for="claim_date">Claim Date:</label>
                    <div class="input-group">
                        <date-picker placeholder="MM/DD/YYYY" id="claim_date" name="claim_date" :disabled="collected == 'yes'" v-model="claim_date" :config="optionsDate"></date-picker>
                        <label for="claim_date" class="fp-calendar input-calender-icon"></label>
                    </div>
                    <div class="field-error">{{ claim_date_error_msg }}</div>
                </div>

                <div class="col form-group" v-show="itemId == undefined || itemData != ''">
                    <label class="control-label require" for="cost_claimed">Cost Claimed:</label>
                    <input type="text" class="form-control" v-model="cost_claimed" id="cost_claimed" :disabled="collected == 'yes'" placeholder="Enter Cost" name="cost_claimed"
                     @input="validateInput($event)"
                    @keypress="isAmountCheck($event)">
                    <div class="field-error">{{cost_claimed_error_msg}}</div>
                </div>
                <div class="col form-group">
                    <label class="control-label" for="period">Claim Type:</label>
                    <v-select class="close-remove" v-model="claim_type" :disabled="collected == 'yes'" name="claim_type" placeholder="Claim Type"
                        label="text" :options="claimTypeArr">
                    </v-select>
                </div>
                <div class="col form-group" v-show="itemId == undefined">
                    <label class="control-label" for="period">Disposition:</label>
                    <v-select class="close-remove" v-model="disposition" :disabled="collected == 'yes'" name="disposition" placeholder="Disposition"
                        label="text" :options="dispositionArr">
                    </v-select>
                </div>
                <div class="col form-group">
                    <label class="control-label" for="period">Part Causing Failure:</label>
                    <v-select v-model="part" name="part" label="text" :disabled="collected == 'yes'" :filterable="false" :options="componentArr" @search="onSearchComponent" placeholder="Search Part" class="custom-ci-auto-search">
                        <template slot="no-options">
                            Search Part...
                        </template>
                        <template slot="option" slot-scope="option">
                            <div class="d-center">
                                {{ option.text }}
                            </div>
                        </template>
                        <template slot="selected-option" slot-scope="option">
                            <div class="selected d-center">
                                {{ option.text }}
                            </div>
                        </template>
                    </v-select>
                </div>

                <div class="col form-group" v-show="itemId == undefined">
                    <label class="control-label" for="period">#Vendor Claim:</label>
                    <input type="text" class="form-control" v-model="vendor_claim_number" :disabled="collected == 'yes'" id="vendor_claim_number" placeholder="Enter Claim Number" name="vendor_claim_number">
                    <!-- <div class="field-error">{{miles_error_msg}}</div> -->
                </div>
                <div class="col form-group" v-show="itemId == undefined">
                    <label class="control-label" for="period">Vendor:</label>
                    <v-select v-model="vendor" name="vendor" label="text" :disabled="collected == 'yes'" :filterable="false" :options="vendorArr" @search="onSearchVendor" placeholder="Search Vendor" class="custom-ci-auto-search">
                        <template slot="no-options">
                            Search Vendor...
                        </template>
                        <template slot="option" slot-scope="option">
                            <div class="d-center">
                                {{ option.text }}
                            </div>
                        </template>
                        <template slot="selected-option" slot-scope="option">
                            <div class="selected d-center">
                                {{ option.text }}
                            </div>
                        </template>
                    </v-select>
                </div>
                <div class="col form-group">
                    <label class="control-label" for="period">Description:</label>
                    <textarea type="text" class="form-control" v-model="description" :disabled="collected == 'yes'" id="description" placeholder="Enter Warranty Description" name="description"></textarea>
                    <!-- <div class="field-error">{{miles_error_msg}}</div> -->
                </div>
            </div>
             <!-- File upload  -->
            <div class="form-row row-cols-md-2 row-cols-1 ach-payment-section">
                    <div class="col form-group verification-section-main">
                        <label :class="'control-label'">File:</label>
                        <div class="custom-dropzone-container custom-photo-user-dropzone dropzone-margin">
                            <div id="app2">
                                <vue-dropzone id="warrantyClaimDocs"
                                    :options="dropzoneOptions"
                                    :destroyDropzone=false
                                    ref="warrentyClaimDropZone"
                                    :headers="dropzoneOptions.headers"
                                    @vdropzone-complete="afterComplete"
                                    @vdropzone-success="storeDocument"
                                    @vdropzone-removed-file="removedSelectedFile"
                                    >
                                </vue-dropzone>
                                <div class="field-error">{{fileerror_msg}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="col form-group"  v-if="dropZonePreviewFiles.length > 0">
                        <div class="policy-attachment attachment-list-box">
                            <label class="control-label" for="attachments"></label>
                            <template  v-for="(uFile,fKey) in dropZonePreviewFiles">
                                <div v-bind:key="'fileDiv'+fKey" class="attachment-list">
                                    <i v-if="uFile.extension == 'pdf'" class="fp-pdf-icon"></i>
                                    <i v-if="uFile.extension == 'doc' || uFile.extension == 'docs'" class="fp-text-document"></i>
                                    <i v-if="uFile.extension == 'jpg' ||  uFile.extension == 'png' ||  uFile.extension == 'jpeg' " class="fp-image"></i>
                                    <a title='View File' href="javascript:void(0)"  v-on:click="openDocument(uFile.url,uFile.extension)" v-bind:key="'fileName'+fKey" >
                                        {{ uFile.display_name }}
                                    </a>
                                    &nbsp;&nbsp;&nbsp;&nbsp;
                                    <button type="button"  v-bind:key="'cancelBtn'+fKey" v-on:click="deleteWarrantyFile(fKey,uFile.file_name);">
                                        <i class="fp-close"></i>
                                    </button>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            <div class="form-group">
                <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <strong id="errorMsg" class="field-error"></strong>
                </div>
            </div>
            <div class="btn-groups">
                <button type="submit" :disabled='!cost_claimedEdit' id="createWarrantyBtn" v-if="$route.params.id > 0 && flag == undefined || (flag != undefined && flag == 'update' )" class="btn btn-primary" v-on:click.prevent="CreateWarrantyClaim">
                <i class="fp-reload"> </i>  Update
                </button>
                <button type="submit" :disabled='!cost_claimedEdit' id="rejecteWarrantyBtn" v-if="$route.params.id > 0 && flag == undefined || (flag != undefined && flag == 'update' )" class="btn btn-primary" v-on:click.prevent="CreateWarrantyClaim(flag='reject')">
                <i class="fp-cancel"> </i>  Reject
                </button>

                <button type="submit" :disabled='!cost_claimedEdit' id="createWarrantyBtn" v-else class="btn btn-primary" v-on:click.prevent="CreateWarrantyClaim" >
                <i class="fp-save"> </i>  Save
                </button>

                <button type="submit" :disabled='!cost_claimedEdit' id="createAndContinueWarrantyBtn" v-if="$route.params.id == undefined && itemId == undefined" class="btn btn-tertiary" v-on:click.prevent="CreateWarrantyClaim(flag='Save and Continue')" >
                <i class="fp-save-continue"> </i>  Save and Continue
                </button>

                <button type="submit" id="cancelWarrantyBtn" class="btn btn-tertiary" v-on:click.prevent="BackWarrantyList">
                <i class="fp-close"> </i>  Cancel
                </button>
            </div>
        </form>
    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins';
import {contractMixins} from '../mixins/contractMixins';

import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';

export default {
  name: "WarrantyClaimCreate",
  components: {
        vueDropzone: vue2Dropzone,

    },
    props: {
        itemData: {
            type: Object,
            required: false,
            default:undefined
        },
        itemId:{
            type: Number,
            required: false,
            default:undefined
        },
        flag:{
            type: String,
            required: false,
            default:undefined
        },
        claimId:{
            type: Number,
            required: false,
            default:undefined
        },
        warrantyData:{
            type: Object,
            required: false,
            default:undefined
        },
        workOrderId:{
            type: Number,
            required:false.valueOf,
            default:undefined,
        },
        workOrderOpenDate:{
            type: Date,
            required:false.valueOf,
            default:undefined,
        }
    },
  mixins:[commonMixins, contractMixins],
  data: () => ({
     permissions: [],
    cantAccessPage: "",
    claim_number: "",
    description: "",
    warranty: null,
    wo_item_id:null,
    effective_date: "",
    period: "",
    periodTypeArr:[{value:"month",text:"Month"},{value:"year",text:"Year"}],
    periodType:{value:"month",text:"Month"},
    miles:"",
    options: {
        format: 'YYYY-MM-DD',
        useCurrent: false,
    },
    loading:false,
    description_error_msg: "",
    starting_point_value_error_msg: "",
    effective_date_error_msg: "",
    period_error_msg: "",
    warranty_type_error_msg:"",
    claim_number_error_msg:'',
    woItemArr:[],
    vendor:'',
    vendorArr:[],
    vendor_claim_number:'',
    part:'',
    componentArr:[],
    disposition:'',
    claim_type:'',
    cost_claimed_error_msg:'',
    cost_claimed:'',
    cost_claimedEdit:true,
    claim_date_error_msg:'',
    claim_date:'',
    optionsDate: {
        format: 'MM/DD/YYYY',
        useCurrent: false,
    },
    failure_date_error_msg:'',
    failure_date:'',
    warranty_error_msg:'',
    warrantyArr:[],
    model:'',
    make:'',
    vin:'',
    year:'',
    truck_type:'',
    unit_no:'',
    wo_item:'',
    assigned_facility:'',
    isTechnician:false,
    role:'',
    woAmount:0,
    wo_error_msg:'',
    collected:'no',
    work_order_id:'',
    filesArr:[],
    existFilesArr:[],
    claimTypeArr:[],
    dropzoneOptions: {
            url: process.env.ROOT_API +"/store-warranty-claim-docs",
            method: 'POST',
            maxFilesize: 10.00, //MB
            maxFiles: 5,
            thumbnailWidth: 150, // px
            thumbnailHeight: 150,
            addRemoveLinks: true,
            acceptedFiles: ".jpg, .jpeg, .png, .pdf , .doc ,.docx",
            headers: {
                'Accept': 'application/json',
                "Authorization": "Bearer "+localStorage.getItem("tkn"),
                'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                "Cache-Control": "no-cache"
            },
            dictRemoveFileConfirmation: "Are you sure?You can\'t revert your action",
            destroyDropzone:false,
            dictDefaultMessage: "Drop files here to upload. Max allowed file size is 10MB.",
        },
    dropZonePreviewFiles:[],
    fileRequired:'require',
    fileerror_msg:'',
    docArr:[],
    validateDocs:[],
    warranty_claims_id: '',
    warranty_id: '',
    from_work_order: false,
  }),
  watch: {
        //check permission change
        // permissions: function (permissions) {
        //     var self = this;
        //     if (permissions.length > 0) {
        //         for (var i = 0; i < permissions.length; i++) {
        //             if (permissions[i].name == 'add_warranty') {
        //                 self.cantAccessPage = true;
        //             }
        //         }
        //     }

        // },
        wo_item: function(val) {

            var self = this;
            var path = window.location.pathname;
            var segments = path.split("/");
            if(!segments[3]){
                self.warranty = '';
            }

// alert(val.vehicle_id);
            if(val != null && val != '' && val.vehicle_id){

                $.ajax({
                    url: process.env.ROOT_API + "/asset/"+val.vehicle_id,
                    type: "GET",
                    headers: this.ajxHeaders,
                    crossDomain: true,
                    dataType:"json",

                    success: function (data) {
                        //if data is edit than dont make model id blank
                        if (data.status == "success") {
                            self.vin = data.content.vin;
                            self.unit_no = data.content.unit_no;
                            self.truck_type = data.content.vtCode+' | '+data.content.vtName;
                            self.assigned_facility = data.content.plCode+' | '+data.content.plName;
                            self.net_book_value = data.content.net_book_value;
                            self.make = data.content.vmCode+' | '+data.content.vmName;
                            if (data.content.vmodelsCode != null && data.content.vmodelsCode != ''){

                                self.model = data.content.vmodelsCode+' | '+data.content.vmodelsName;

                            }
                            if (data.content.year != null){

                                self.year = data.content.year;

                            }
                            // if(data.content.vehicle_group_id != null){
                            //   console.log('vehicle_group_id is not null');
                            //   self.loadWarranties(data.content.vehicle_group_id);
                            // } else{
                              console.log('vehicle_group_id is null');
                              self.loadWarranties(val);
                            // }

                        }
                    },
                    error: function (jqXHR, exception) {
                        self.Registerbtn = "Register";
                        self.generateStatusCodeMessage(jqXHR,true,'asset-data')
                    }
                });
            }
            if (val != null && val != '' && val.amount){
                self.woAmount = val.amount;
            }

        },
  },
  created: function() {

  },
  mounted: function() {
        var self = this;
        // self.getPermissions();
        // self.loadWarrantyTypes();
        self.loadFieldData(['claim_types']);
        var path = window.location.pathname;
        var segments = path.split("/");

        var userObj = JSON.parse(localStorage.getItem("user_obj"));
        if (userObj != null) {
            // var userJson = JSON.parse(userObj);
            if (userObj.roles.length > 0) {
                self.role = userObj.roles[0].name;
                // if(self.role.toLowerCase() == 'technician'){
                //     self.isTechnician = true;
                // }
            }
        }

        if (self.itemId != undefined){
            console.log(self.itemData);
            // self.workOrderItemFetch(self.itemId);
            self.wo_item = {text:self.itemData.wo_no+' | '+self.itemData.vmrs_name+' | '+self.itemData.task_name,value:self.itemData.woItemId,
                            vehicle_id:self.itemData.vehicle_id,
                            amount:self.itemData.amount,
                            vmrs_id:self.itemData.vmrsId,
                            miles:self.itemData.miles
                        };
            if(self.workOrderId != undefined){
                self.from_work_order = true;
                self.work_order_id = self.workOrderId;
            }
            if (self.claimId != undefined && self.claimId != '' && self.claimId > 0){
                self.loadClaimData(self.claimId);
            }else{
                setTimeout(function(){
                    self.getClaimCode();
                },500);
            }
        }else{
            if (segments[3]){

                self.loadClaimData(segments[3]);

            }else{
                self.getClaimCode();
            }
        }

        //self.loadWarranties();
  },
  methods: {
    validateInput(evt) {
      var self = this;
      evt = (evt) ? evt : window.event;
      if(evt.target.value > 999999.99) {
        self.cost_claimedEdit = false;
        self.cost_claimed_error_msg = "Amount value exceed";
      } else {
        self.cost_claimedEdit = true;
        self.cost_claimed_error_msg = "";
      }

    },
    integerCheck: function (evt) {
      var self = this;
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            evt.preventDefault();
        } else {
            if(self.cost_claimedEdit) {
              return true;
            } else {
              evt.preventDefault();
            }
            return true;
        }
    },
    getClaimCode(){
        var self = this;
        self.$parent.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/claim/code",
            type: "POST",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.$parent.loading = false;
                console.log(data);
                if (data.status == "success") {
                    self.claim_number = data.content;
                }
            },
            error: function (jqXHR, exception) {
                self.$parent.loading = false;
                self.generateStatusCodeMessage(jqXHR,true,'customer-code')
            }
        });
    },

    loadClaimData:function(claimId){
        var self = this;

        self.$parent.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/warranty-claim/fetch/"+claimId,
            type: "GET",
            headers: this.ajxHeaders,
            crossDomain: true,
            dataType: "json",
            success: function (data) {
                self.$parent.loading = false;
                // self.wo_item = data.content;
                self.id = data.content.id;
                self.warranty_claims_id = data.content.id;
                self.warranty_id = data.content.warranty_id;
                self.wo_item = {text:data.content.work_order_no+' | '+data.content.code+' | '+data.content.task,
                                value:data.content.wo_item_id,
                                vehicle_id:data.content.vehicle_id,
                                vmrs_id:data.content.vmrsId,
                                miles:data.content.miles
                            };
                self.claim_number = data.content.claim_number;
                self.work_order_id = data.content.work_order_id;

                if (data.content.warranty_id){
                    // setTimeout(() => {
                        self.warranty = {text:data.content.warName+'('+data.content.warCode+')',value:data.content.warranty_id};
                    // }, 2000);

                }
                self.failure_date = data.content.failure_date;
                self.claim_date = data.content.claim_date;
                self.cost_claimed = data.content.cost_claimed;
                for(var i =0;i < self.claimTypeArr.length;i++){
                    if (self.claimTypeArr[i].code == data.content.claim_type){

                        self.claim_type = {text:self.claimTypeArr[i].text,value:data.content.claim_type,description:self.claimTypeArr[i].description,code:self.claimTypeArr[i].code};

                    }
                }
                for(var j =0;j < self.dispositionArr.length;j++){
                    if (self.dispositionArr[j].value == data.content.disposition){

                        self.disposition = {text:self.dispositionArr[j].text,value:data.content.disposition};

                    }
                }
                if (data.content.item_id){

                    self.part = {text:data.content.itemCode+' | '+data.content.itemName,value:data.content.item_id};

                }
                self.description = data.content.description;
                self.vendor_claim_number = data.content.vendor_claim_number;
                self.vendor = {text:data.content.veName,value:data.content.vendor_id};
                self.collected = data.content.collected;
                self.woAmount = data.content.wo_amount;
                //if files exists
                if(data.docs){
                    self.dropZonePreviewFiles = data.docs;
                    self.loadFilesPreview();
                }
                // if(data.content.file_path != null && data.content.file_path != ""){

                // }
            },
            error: function (jqXHR, exception) {
                self.$parent.loading = false;
                self.Registerbtn = "Register";
                self.generateStatusCodeMessage(jqXHR,true,'asset-group-warranties-search')
            }
        });
    },

    onSearchComponent(search, loading) {
        var self = this;
        if (search.length > 1) {
           // console.log("wo_item"+self.wo_item.value);
            var componetWorkOrderID = self.wo_item.value;
            if ( componetWorkOrderID == undefined ) {
                alert("Please select Work Order Item first");
                return;
            }
            loading(true);
            self.searchField(loading, search, 'component', self.wo_item.value);
        }
    },

    onSearchVendor(search, loading) {
        var self = this;
        self.po_error_msg = "";
        if (search.length > 2) {

            loading(true);
            self.searchField(loading, search, 'bill_vendor', '');
        }
    },
    onSearchwoitem(search, loading) {
        var self = this;
        self.po_error_msg = "";
        if (search.length > 6) {

            loading(true);
            self.searchField(loading, search, 'wo_item', '');
        }
    },
    loadWarranties(val){
        var self = this;
        var path = window.location.pathname;
        var segments = path.split("/");
        var url = segments[1];
        $.ajax({
            url: process.env.ROOT_API + "/warranties/search",
           type: "GET",
            headers: this.ajxHeaders,
            data:{
              vehicle_id : val.vehicle_id,
              miles: val.miles,
              open_date: self.workOrderOpenDate,
              vmrs: val.vmrs_id,
              url: url,
            },
            crossDomain: true,
            dataType: "json",
            success: function (data) {
                //console.log(data.content.email);
                // if (data.status == "success") {
                    // console.log(data.content);
                    if(data.length > 0){
                        self.warrantyArr = data;
                        if(self.warrantyData != undefined){
                            self.warranty = {text:self.warrantyData.text,value:self.warrantyData.value};
                        }
                    }else{
                        self.warranty = '';
                        self.warranty_error_msg = "No Warranties found!";
                    }

                    // if (self.warrantyArr != undefined && self.warrantyArr.length > 0 && self.warranty_id != ''){
                    //   for (let i = 0; i < self.warrantyArr.length; i++) {
                    //       if (self.warrantyArr[i].value === self.warranty_id) {
                    //           self.warranty = self.warrantyArr[i];
                    //           break; // Exit the loop once a match is found
                    //       }
                    //   }
                    // }
                // }

            },
            error: function (jqXHR, exception) {
                self.Registerbtn = "Register";
                self.generateStatusCodeMessage(jqXHR,true,'asset-group-warranties-search')
            }
        });
    },

    BackWarrantyList() {
      var self = this;
      if (self.itemId != undefined){
        //   self.$parent.create_warranty_claim = false;
        self.$parent.cancelWarrantyClaim();
      }else{
        self.$router.push("/warranty-claim/list");
      }
    },

    CreateWarrantyClaim(flag) {

        var self = this;
        var error = false;

        if (self.collected == 'yes'){
            self.$swal('','You have already created the collection for this claim','info');
            return;
        }

        self.claim_date_error_msg = "";
        self.failure_date_error_msg = "";
        self.warranty_error_msg = "";
        self.claim_number_error_msg = "";
        self.wo_error_msg = '';
        self.cost_claimed_error_msg = '';
        self.fileerror_msg = '';

         if (self.itemId == undefined && (self.cost_claimed < self.woAmount)) {
            if (confirm('Are you sure about Cost claimed  being less than the Total Work Order Cost? ')) {

            } else{
                error = true;
            }
            //  alert("Cost claimed should be more than the Total Work Order Cost.");
            //  error = true;
         }

        if (!self.claim_number || self.claim_number == null || self.claim_number == "") {
            self.claim_number_error_msg = "Claim Number is required.";
            error = true;
        }
        if (!self.wo_item || self.wo_item == null || !self.wo_item.value) {
            self.wo = "Work Order Item is required.";
            error = true;
        }

        if (self.warranty == null || !self.warranty.value || self.warranty.value == "") {
            self.warranty_error_msg = "Warranty is required.";
            error = true;
        }

        if (!self.failure_date || self.failure_date == null || self.failure_date == "") {
            self.failure_date_error_msg = "Failure Date is required.";
            error = true;
        }
        if (!self.claim_date || self.claim_date == null || self.claim_date == "") {
            self.claim_date_error_msg = "Claim Date is required.";
            error = true;
        }

        if (self.itemId == undefined && (self.cost_claimed == null || self.cost_claimed == '' || self.cost_claimed == 0)) {
            self.cost_claimed_error_msg = "Cost Claim is required.";
            error = true;
        }

        // if(!self.dropZonePreviewFiles.length && !self.docArr.length){
        //     self.fileerror_msg = "File is required.";
        //     error = true;
        // }

        if (self.docArr.length > 0 ) {
            if (self.validateDocs.length > 0) {
                for (var i = 0;i < self.validateDocs.length;i++) {
                    let fileObj = self.validateDocs[i];

                    if (fileObj.extension != undefined) {
                        if (fileObj.extension == "jpeg" || fileObj.extension == "png" || fileObj.extension == "jpg" || fileObj.extension == "pdf" || fileObj.extension == "doc" || fileObj.extension == "docx" || fileObj.extension == "msword" || fileObj.extension == "vnd.openxmlformats-officedocument.wordprocessingml.document") {

                        }else{
                            self.fileerror_msg = "Only Images or PDF or Doc Files Are Allowed (.jpg / .jpeg / .png / .pdf / .doc / .docx).";
                            error = true;
                        }
                    }

                    if (fileObj.size != undefined) {
                        if(fileObj.size > 10000000){
                            self.fileerror_msg = "File size should not be greater than 10 MB.";
                            error = true;
                        }
                    }
                }
            }
        }

        if(self.docArr.length > 5){
            self.fileerror_msg = "Cannot upload more than 5 files.";
            error = true;
        }

        if (!error) {

            self.$parent.loading = true;
            var path = window.location.pathname;
            var segments = path.split("/");
            var id = '';
            if (self.itemId != undefined){
                if (self.claimId != '' && self.claimId != undefined){
                    id = self.claimId;
                }
            }else{
                if (segments[3]){
                    id = segments[3];
                }
            }

            if (id != '')
            {
                $("#createWarrantyBtn").val("Updating ...");
                $("#createWarrantyBtn").prop("disabled", true);
                $("#cancelWarrantyBtn").prop("disabled",true);
            } else {
                if (flag == "Save and Continue") {

                    $("#createAndContinueWarrantyBtn").val("Saving ...");
                    $("#createWarrantyBtn").prop("disabled", true);
                    $("#createAndContinueWarrantyBtn").prop("disabled", true);
                    $("#cancelWarrantyBtn").prop("disabled",true);

                }else{

                    $("#createWarrantyBtn").val("Saving ...");
                    $("#createWarrantyBtn").prop("disabled", true);
                    $("#createAndContinueWarrantyBtn").prop("disabled", true);
                    $("#cancelWarrantyBtn").prop("disabled",true);
                }

            }

            var fields = $('#WarrantyClaimForm').serializeArray();

            fields.push({name: "wo_item_id", value: self.wo_item.value});
            if (self.itemId == undefined || self.itemData != ''){

                fields.push({name: "warranty_id", value: self.warranty.value});

            }
            fields.push({name: "claim_number", value: self.claim_number});
            fields.push({name: "claim_type", value: self.claim_type.value});
            fields.push({name: "disposition", value: self.disposition.value});
            fields.push({name: "vendor_id", value: self.vendor.value});
            fields.push({name: "item_id", value: self.part.value});
            fields.push({name: "id", value: self.warranty_claims_id});
            fields.push({name: "flag", value: flag});
            fields.push({name: "docArr", value: JSON.stringify(self.docArr)});
            $.ajax({
                url: process.env.ROOT_API + "/warranty-claim/create",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.$parent.loading = false;
                    if (id != '')
                    {
                        $("#createWarrantyBtn").val("Update");
                        $("#createWarrantyBtn").prop("disabled", false);
                        $("#cancelWarrantyBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#createAndContinueWarrantyBtn").val("Save and Continue");
                            $("#createWarrantyBtn").prop("disabled", false);
                            $("#createAndContinueWarrantyBtn").prop("disabled", false);
                            $("#cancelWarrantyBtn").prop("disabled",false);

                        }else{

                            $("#createWarrantyBtn").val("Save");
                            $("#createWarrantyBtn").prop("disabled", false);
                            $("#createAndContinueWarrantyBtn").prop("disabled", false);
                            $("#cancelWarrantyBtn").prop("disabled",false);

                        }
                    }
                    if (data.status == "success") {

                        if (flag == "Save and Continue") {

                            $("#WarrantyForm").trigger("reset");
                            self.wo_item = '';
                            self.claim_number = '';
                            self.warranty = '';
                            self.failure_date = '';
                            self.claim_date = '';
                            self.cost_claimed = '';
                            self.claim_type = '';
                            self.disposition = '';
                            self.part = '';
                            self.description = '';
                            self.vendor_claim_number = '';
                            self.vendor = '';

                        }else{
                            if (self.itemId != undefined){
                                self.$parent.create_warranty_claim = false;
                                self.$parent.taskArr = [];
                                self.claimId = '';
                                self.claim_number = '';
                                self.$parent.workOrderItemData();
                            }else{
                                self.$router.push("/warranty-claim/list");
                            }
                        }

                    } else {
                        if (data.content.length > 0) {
                            var err = "";
                            for (var i = 0; i < data.content.length; i++) {
                                err += data.content[i] + "<br>";
                            }
                            $("#errorMsg").html(err);
                            $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                $(".alert-warning").removeClass("show");
                                $(".alert-warning").addClass("hide");
                            }, 10000);
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.$parent.loading = false;
                    if (id != '')
                    {
                        $("#createWarrantyBtn").val("Update");
                        $("#createWarrantyBtn").prop("disabled", false);
                        $("#cancelWarrantyBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            // $("#VehicleStatusForm").trigger("reset");

                            $("#createAndContinueWarrantyBtn").val("Save and Continue");
                            $("#createWarrantyBtn").prop("disabled", false);
                            $("#createAndContinueWarrantyBtn").prop("disabled", false);
                            $("#cancelWarrantyBtn").prop("disabled",false);

                        }else{

                            $("#createWarrantyBtn").val("Save");
                            $("#createWarrantyBtn").prop("disabled", false);
                            $("#createAndContinueWarrantyBtn").prop("disabled", false);
                            $("#cancelWarrantyBtn").prop("disabled",false);

                        }
                    }
                    if (jqXHR.status == 0) {
                        self.errorMsg = "Remote server cannot be reached";
                    } else {
                        //redirect to login page if user not authenticated
                        if (jqXHR.status == 401) {
                            //clear previous data
                            localStorage.removeItem("user_obj");
                            localStorage.removeItem("tkn");

                            self.$router.push("/");
                        }
                        $("#errorMsg").html(jqXHR.responseJSON.message);
                        $(".alert-warning").toggleClass("show");
                        setTimeout(function () {
                            $(".alert-warning").removeClass("show");
                            $(".alert-warning").addClass("hide");
                        }, 10000);
                    }
                }
            });
        }


    },

    deleteWarrantyFile: function(key,file){

        var self = this;

        if (confirm('Are you sure that you want to remove file? ')) {

            if(self.warranty_claims_id != '' && self.warranty_claims_id != undefined){
                self.$parent.loading = true;

                $.ajax({
                    url: process.env.ROOT_API + "/remove-warranty-claim-file",
                    type: "POST",
                    crossDomain: true,
                    dataType: "json",
                    headers: this.ajxHeaders,
                    data: {
                        id: self.warranty_claims_id,
                        doc_path:file
                    },
                    success: function(data) {
                        self.$parent.loading = false;
                        if (data.status == "success") {
                            self.filesArr.splice(key,1);
                            self.docArr.splice(key,1);
                            self.validateDocs.splice(key,1);
                            self.loadClaimData(self.warranty_claims_id);
                            if (self.valuesFound) {
                                self.valuesFound = false;
                                self.matchingValuesError = [];
                            }
                        }
                    },
                    error: function(jqXHR, exception) {
                        self.$parent.loading = false;
                        self.filesArr.splice(key,1);
                        self.docArr.splice(key,1);
                        self.validateDocs.splice(key,1);
                        self.generateStatusCodeMessage(jqXHR,true,'vendor-invoice-doc-remove');
                    }
                });

            } else{
                self.filesArr.splice(key,1);
                self.$refs.files.value = '';
            }
        }

    },
    afterComplete(file,response){
        var self = this;
    },
    storeDocument(file,response){
        var self = this;
        self.fileerror_msg = "";
        var uploadResponse = response;

        //push doc path in doc array
        self.docArr.push(uploadResponse.content);
        self.filesArr.push(file);
        if (file.type != undefined) {
            var extension = file.type.split("/");
            self.validateDocs.push({
                file_name:file.name,
                size:file.size,
                extension:extension[1]
            });
        }
    },
    removedSelectedFile(file, xhr, error) {
        var self = this;
        self.fileerror_msg = "";
        if (file.xhr != undefined) {
            var fileName = JSON.parse(file.xhr.response).content;

            var fileArr = fileName.split("/");

            self.removeFileFromServer(fileArr[1],"temp");

            for(var i = 0;i<self.docArr.length;i++){
                if ( self.docArr[i].includes(fileName)) {
                    self.docArr.splice(i,1);
                    self.validateDocs.splice(i,1);
                    self.filesArr.splice(i,1);
                }
            }
        }
    },
    removeFileFromServer(file,flag){
        var self = this;
        var billId = self.$route.params.id;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/remove-warranty-claim-file",
            type: "POST",
            data: {
                doc_path : file,
                bill_id: billId,
                flag:flag
            },
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,true,'vendor-inv-doc-remove')
            }
        });
    },
    removeAllFiles() {
        var self = this;
        self.$refs.warrentyClaimDropZone.removeAllFiles();
    },
    //load files in drop zone
    loadFilesPreview:function() {
        var self = this;
        self.docArr = [];
        self.validateDocs = [];
        if ( self.dropZonePreviewFiles.length > 0 ) {
            for ( var i = 0;i<self.dropZonePreviewFiles.length;i++ ) {
                var url = self.dropZonePreviewFiles[i].url;
                // get file path from url
                self.docArr.push(self.getFilePathFromUrl(self.dropZonePreviewFiles[i].url));
                self.validateDocs.push({
                    file_name:self.dropZonePreviewFiles[i].display_name,
                    extension:self.dropZonePreviewFiles[i].extension
                });
            }
        }
    },
    getFilePathFromUrl (value) {

        var path = "";
        var src = value.split('/');
        var file_name = src[src.length - 1];
        var orgPath = src[src.length - 2];
        path = orgPath + "/" + file_name;
        return path;

    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/WarrantyClaimForm.vue